import axios from 'axios'
import { KEYS, getItem } from '@/store/local/localStorage'

let instance; // eslint-disable-line

if (process.env.NODE_ENV === 'development') {
  instance = axios.create({
    baseURL: '/'
  })
} else {
  instance = axios.create(process.env.API_URL && process.env.API_URL !== '' ? {
    baseURL: process.env.API_URL
  } : null)
}

instance.defaults.headers.common['Authorization'] = getItem(KEYS.LOGIN.jwt)

export default instance



// WEBPACK FOOTER //
// ./src/utils/api-axios.js